@if (isLoading) {
<div class="loading-spinner-container">
    <div class="loading-spinner">
    </div>
</div>
}

<div class="splash">
    <div class="row align-items-center">
        <div class="col-sm-5 col-md-4 offset-md-2 col-lg-3 offset-lg-2">
           
            <div class="row">
                <div class="col">
                    <img src="images/deloitte.svg" alt="Deloitte" class="splash__logo mb-3" />        
                </div>
            </div>

            <div class="row">
                <div class="col">
                    <p class="splash__title">
                        Welcome to the <strong>Tax CMS</strong>
                    </p>
                    <p class="mt-3 mb-3">
                        For more information on how to use this tool, please get in touch.
                    </p>

                    <!-- Inline Email Form -->
                    <form [formGroup]="emailForm" (ngSubmit)="submitEmail()" novalidate>
                        <div class="email-input-wrapper mb-3">
                            <label class="form-label" style="color: white; font-size: 0.875rem; margin-bottom: 0.5rem;">Email address</label>
                            <input 
                                #emailInput
                                type="email" 
                                class="form-control" 
                                formControlName="email" 
                                placeholder="you@company.com" 
                                [disabled]="isLoading"
                                style="background-color: transparent; border: none; border-bottom: 1px solid rgba(255,255,255,0.3); border-radius: 0; color: white; padding: 8px 0;"
                            />
                            @if (emailForm.get('email')?.invalid && emailForm.get('email')?.touched) {
                                <div class="text-danger mt-1" style="font-size: 0.875rem;">
                                    @if (emailForm.get('email')?.errors?.['required']) {
                                        <span>Email is required.</span>
                                    }
                                    @if (emailForm.get('email')?.errors?.['email']) {
                                        <span>Please enter a valid email address.</span>
                                    }
                                </div>
                            }
                        </div>
                        <div class="mb-4 text-end">
                            <button type="submit" class="btn btn-link text-info p-0" [disabled]="isLoading" style="text-decoration: none;">
                                @if (isLoading) {
                                    <small>Processing... <i class="fa fa-arrow-right ms-1"></i></small>
                                } @else {
                                    <small>Sign In <i class="fa fa-arrow-right ms-1"></i></small>
                                }
                            </button>
                        </div>
                    </form>

                    <small> Need assistance? | <a href="mailto:gtls@deloitte.com?subject= Tax CMS - General Enquiry">Contact us</a></small>
                </div>
            </div>
        </div>
        
        <div class="col-sm-7 col-md-6">       
            <div class="splash__image">
               <img src="/images/globe.jpg"/> 
            </div>
        </div>
    </div>
</div>
